angular.module('impactx.address').controller('BasketAddressSelectionPanelCtrl', [
    'BasketAddressSelectionPanel',
    'themeFactory',
    BasketAddressSelectionPanelController]);

function BasketAddressSelectionPanelController(BasketAddressSelectionPanel, themeFactory) {
    var self = this;

    self.theme = themeFactory.getTheme();
    self.data = self.config.data;
    self.selectedAddress = undefined;

    self.apply = function () {
        BasketAddressSelectionPanel.setSelection(self.selectedAddress);
        BasketAddressSelectionPanel.closePanel();
    };

    self.close = function () {
        BasketAddressSelectionPanel.closePanel();
    };
}